import { Component, ElementRef, HostListener, ViewChild } from '@angular/core';
import { MatTabChangeEvent, MatTabsModule } from '@angular/material/tabs';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faMars, faVenus, faCheck, faClose, faTrash } from '@fortawesome/free-solid-svg-icons';
import { CommonModule } from '@angular/common';
import { ApiServicesService } from '../services/api-services.service';
import { UserDetailsService } from '../services/user-details.service';
import { RouterLink } from '@angular/router';
import { SnackbarService } from '../services/snackbar.service';

@Component({
  selector: 'app-viewed-histry',
  standalone: true,
  imports: [CommonModule, FontAwesomeModule, MatTabsModule, RouterLink],
  templateUrl: './viewed-histry.component.html',
  styleUrl: './viewed-histry.component.css'
})
export class ViewedHistryComponent {
  famale = faMars;
  fafemale = faVenus;
  faCheck = faCheck;
  faCancel = faClose;
  fatrash = faTrash;
  viewedMe: any[] = [];
  viewed: any[] = [];
  userData: any = {};
  limit: any = 10;
  page: any = 1;
  totalPages: any = 1;
  view_responce: boolean = true;
  activeTab = 'I Viewed';

  constructor(private snackbarService:SnackbarService,private apiservices: ApiServicesService, private userdetails: UserDetailsService) {
  }

  ngOnInit() {
    this.IviewedCall(this.page, this.limit);
  }

  onTabChange(event: MatTabChangeEvent) {
    if (event.tab.textLabel === 'I Viewed') {
      this.view_responce = true;
      this.IviewedCall(1, this.limit);
      this.activeTab = 'I Viewed';
    }
    if (event.tab.textLabel === 'Viewed Me') {
      this.view_responce = true;
      this.viewedMeCall(1, this.limit);
      this.activeTab = 'Viewed Me';
    }
  }

  viewedMeCall(page: any, limit: any) {
    this.apiservices.ViewedMe(page, limit).subscribe({
      next: (friends: any) => {
        if (page == 1) {
          this.viewedMe = friends.profilesViewedMe || [];
        } else {
          this.viewedMe = [...this.viewedMe, ...(friends.profilesViewedMe || [])];
        }
        this.page = friends.currentPage;
        this.totalPages = friends.totalPages
        this.view_responce = false;
      },
      error: (err) => {
        console.error('Error fetching states:', err);
        this.snackbarService.openCustomSnackbar(
          {
            icon: false,
            message: err.error.message,
            className: 'failed',
          }
        );
      }
    });
  }

  IviewedCall(page: any, limit: any) {
    this.apiservices.Viewed(page, limit).subscribe({
      next: (friends: any) => {
        if (page == 1) {
          this.viewed = friends.profilesIViewed || [];
        } else {
          this.viewed = [...this.viewed, ...(friends.profilesIViewed || [])];
        }
        this.page = friends.currentPage;
        this.totalPages = friends.totalPages
        this.view_responce = false;
      },
      error: (err) => {
        console.error('Error fetching states:', err);
        this.snackbarService.openCustomSnackbar(
          {
            icon: false,
            message: err.error.message,
            className: 'failed',
          }
        );
      }
    });
  }


  @ViewChild('scrollContainer', { static: true }) scrollContainer!: ElementRef;

  @HostListener('window:scroll', ['$event'])
  onScroll(event: Event): void {
    if (!this.scrollContainer) return;
  
    const target = this.scrollContainer.nativeElement as HTMLElement;
    const rect = target.getBoundingClientRect(); // Get position relative to viewport
    const windowHeight = window.innerHeight;
    // Ensure the API is called only when the user is 100px from the bottom
    if (
      rect.bottom <= windowHeight + 100 && // Triggers 100px before the bottom
      this.page < this.totalPages &&
      !this.view_responce
    ) {
      this.page++;
      this.view_responce = true;
  
      if (this.activeTab === 'I Viewed') {
        this.IviewedCall(this.page, this.limit);
      }
      if (this.activeTab === 'Viewed Me') {
        this.viewedMeCall(this.page, this.limit);
      }
    }
  }



  // @ViewChild('scrollContainer', { static: true }) scrollContainer!: ElementRef;
  // @HostListener('window:scroll', ['$event'])
  // onScroll(: void {
  //   if (!this.scrollContainer) return;
  
  //   const target = this.scrollContainer.nativeElement as HTMLElement;
  //   const rect = target.getBoundingClientRect(); // Get element position relative to the viewport
  //   const windowHeight = window.innerHeight;
  
  //   // Check if the element is visible near the bottom of the viewport
  //   if (rect.bottom <= windowHeight + 100 && !this.isLoading && this.page < this.totalPages) {
  //     this.isLoading = true;
  //     const route = this.route.snapshot.params;
  //     if (this.activeTab === 'I Viewed') {
  //       this.IviewedCall(this.page, this.limit);
  //     }
  //     if (this.activeTab === 'Viewed Me') {
  //       this.viewedMeCall(this.page, this.limit);
  //     }
  //   }
  // }
  
  



 
    
}
